import { Component} from "@angular/core";


@Component({
    templateUrl: './cert-overview.component.html',
    standalone: false
})
export class CertOverviewComponent {
}